// extracted by mini-css-extract-plugin
module.exports = {"options":"Options_options__GN--i","option":"Options_option___BNvQ"};